import { render, staticRenderFns } from "./EditorNavLinksModal.vue?vue&type=template&id=009a54ac&"
import script from "./EditorNavLinksModal.vue?vue&type=script&lang=js&"
export * from "./EditorNavLinksModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports